import { OrganizationAvailabilityApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const organizationAvailabilityApi = new OrganizationAvailabilityApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
